import DevExpress from 'devextreme';
import { dxToolbarItem } from 'devextreme/ui/toolbar';

import { dxWidgetNames } from '../dx-widget-names.enum';

export interface DxWidgetNameToInterface {
	[dxWidgetNames.dxButton]: DevExpress.ui.dxButtonOptions;
	[dxWidgetNames.dxSelectBox]: DevExpress.ui.dxSelectBoxOptions<any>;
	[dxWidgetNames.dxTextBox]: DevExpress.ui.dxTextBoxOptions<any>;
	[dxWidgetNames.dxTextArea]: DevExpress.ui.dxTextAreaOptions;
	[dxWidgetNames.dxButtonGroup]: DevExpress.ui.dxButtonGroupOptions;
	[dxWidgetNames.dxNumberBox]: DevExpress.ui.dxNumberBoxOptions;
}

/** The type from Dx library is missing props... */
export interface ToolbarComponentSettings<T extends keyof DxWidgetNameToInterface> extends Omit<dxToolbarItem, 'widget'> {
	widget?: dxWidgetNames;
	name: string;
	options?: DxWidgetNameToInterface[T];
	sortIndex?: number;
}

export class ToolbarHelper {
	/**
	 *
	 */
	constructor(private toolbarOptions: DevExpress.ui.dxToolbarOptions) {}

	addToolbarItem<T extends keyof DxWidgetNameToInterface = dxWidgetNames.dxButton>(
		toolbarItem: ToolbarComponentSettings<T>
	): ToolbarHelper {
		addOrUpdateToolbarItems(this.toolbarOptions.items, toolbarItem);
		return this;
	}

	getOptions(): DevExpress.ui.dxToolbarOptions {
		return this.toolbarOptions;
	}
}

export function addOrUpdateToolbarItems(
	currentItems: ToolbarComponentSettings<any>[],
	...itemsToAddOrUpdate: ToolbarComponentSettings<any>[]
) {
	return itemsToAddOrUpdate.reduce((pv, cv) => {
		const itemIndex = pv.findIndex(item => item.name === cv.name);
		if (itemIndex !== -1) {
			pv.splice(itemIndex, 1, cv);
		} else {
			pv.unshift(cv);
		}

		return pv;
	}, currentItems);
}
